import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, fileUrl } from "@/lib/api";
import { Plus, Search, BookOpen, Clock } from "lucide-react";
import VerifiedBadge from "@/components/VerifiedBadge";
import { stripHtml } from "@/components/RichTextEditor";

const readingMinutes = (html) => {
  const text = stripHtml(html);
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};

export default function BlogsList() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");

  const load = async () => {
    try {
      const [b, c] = await Promise.all([api.get("/blogs", { params: { q: q||undefined, category: cat } }), api.get("/blog-categories")]);
      setItems(b.data); setCats(c.data);
    } catch (err) { console.error(err); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [cat]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [q]);

  return (
    <Layout>
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-xs uppercase tracking-widest text-bizma-sage font-bold">Berbagi Ilmu</div>
          <h1 className="text-3xl sm:text-4xl font-display font-bold mt-1">Blog</h1>
          <p className="text-bizma-subtext mt-2">Artikel & pengalaman dari sesama pelaku usaha.</p>
        </div>
        <Link to="/app/blog/new" className="btn-primary" data-testid="new-blog-btn"><Plus size={16}/> Tulis Artikel</Link>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-bizma-subtext" size={18}/>
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Cari artikel..." className="input-bizma pl-11" data-testid="blog-search" />
        </div>
        <select value={cat} onChange={(e)=>setCat(e.target.value)} className="input-bizma sm:w-56" data-testid="blog-cat-filter">
          <option value="all">Semua Kategori</option>
          {cats.map(c => <option key={c.category_id} value={c.name}>{c.name} ({c.count ?? 0})</option>)}
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="blogs-grid">
        {items.map(b => (
          <Link key={b.blog_id} to={`/app/blog/${b.blog_id}`} className="felt-card overflow-hidden transition-transform hover:-translate-y-1 hover:shadow-md" data-testid={`blog-card-${b.blog_id}`}>
            {b.photo_path ? <div className="aspect-video bg-bizma-muted"><img src={fileUrl(b.photo_path)} alt="" className="w-full h-full object-cover"/></div> : <div className="aspect-video bg-bizma-muted grid place-items-center text-bizma-subtext"><BookOpen size={32}/></div>}
            <div className="p-5">
              <div className="text-xs uppercase tracking-widest text-bizma-sage font-bold flex items-center justify-between gap-2">
                <span>{b.category}</span>
                <span className="inline-flex items-center gap-1 text-bizma-subtext normal-case font-medium tracking-normal" data-testid={`blog-reading-time-${b.blog_id}`}><Clock size={11}/> {readingMinutes(b.content)} menit baca</span>
              </div>
              <h3 className="font-display font-semibold text-lg mt-1">{b.title}</h3>
              <p className="mt-2 text-sm text-[#4A4743] line-clamp-2">{stripHtml(b.content).slice(0, 200)}</p>
              <div className="mt-3 flex items-center gap-2 text-xs text-bizma-subtext">
                <span>oleh <span className="font-medium text-bizma-ink">{b.author_name}</span></span>
                {b.author_verified && <VerifiedBadge size={12}/>}
                <span>· {new Date(b.created_at).toLocaleDateString("id-ID")}</span>
              </div>
            </div>
          </Link>
        ))}
        {items.length === 0 && <div className="col-span-full felt-card p-10 text-center text-bizma-subtext">Belum ada artikel.</div>}
      </div>
    </Layout>
  );
}
